module.exports = __webpack_public_path__ + "static/img/setingu4.072aff85.png";